//#region src/modules/Files/utils/open-file-picker.ts
var openFilePicker = (onFiles, opts = {
	accept: "*",
	multiple: true
}) => {
	const input = document.createElement("input");
	input.type = "file";
	input.id = "fileInput";
	input.style.display = "none";
	if (opts.capture) input.capture = opts.capture;
	else if (opts.accept) input.accept = opts.accept;
	input.multiple = !!opts.multiple;
	input.onchange = function() {
		onFiles(input.files || new FileList());
		document.body.removeChild(input);
	};
	document.body.appendChild(input);
	input.click();
};
//#endregion
export { openFilePicker };

//# sourceMappingURL=open-file-picker.js.map